import { useClient, useDictionary } from '@adamlip/okeoke.client';
import { Card, CardBody, CardFooter, CardHeader } from '@nextui-org/react';
import IconComponent from 'components/IconComponent';
import { useEffect, useState } from 'react';

function Achievements({ getVipAchievements }) {
  const { getName } = useClient();
  const { getValue } = useDictionary();
  const [userAchievements, setUserAchievements] = useState(null);

  const fetchAch = () => {
    getVipAchievements()
      ?.then((res) => {
        if (res?.success) {
          let data = res?.data;
          setUserAchievements(data);
          //let stamps = data?.filter((item) => item?.stampsNeeded);
          //setStampsAchievements(stamps);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    fetchAch();
    //eslint-disable-next-line
  }, []);

  console.log(userAchievements);
  return (
    <div className='flex flex-col gap-2'>
      {userAchievements?.map((item, index) => {
        const isUsingStamps = item?.stampsNeeded;
        return (
          <Card key={index} className='bg-default '>
            <CardHeader>{isUsingStamps ? getName(item?.customName) : getValue(`app_${item?.achievementType}`)}</CardHeader>
            <CardBody>
              {isUsingStamps && (
                <div className='flex flex-row gap-2 flex-wrap w-full'>
                  {Array.from({ length: item.stampsNeeded }, (_, i) => (
                    <div
                      key={i}
                      style={{
                        opacity: i >= item?.userStamps?.length ? 0.3 : 1,
                      }}>
                      <div className='h-6 w-6'>
                        <IconComponent iconCode={item?.attributes?.stampIcon || 'hamburger'} className={'current'} />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </CardBody>
            <CardFooter className='justify-between'>
              <p className='opacity-80'>
                {item?.userAchievements?.length} {getValue('app_vip_userAchievements_count')}
              </p>
              {isUsingStamps && (
                <p>
                  {item?.userStamps?.length}/{item?.stampsNeeded}
                </p>
              )}
            </CardFooter>
          </Card>
        );
      })}
    </div>
  );
}

export default Achievements;
